import { Component, EventEmitter, inject, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslocoPipe } from '@jsverse/transloco';
import { Subject } from 'rxjs';
import { ErrorHandlerService } from '../../../../../_shared/services/error-handler.service';
import { InsuranceClaimsService } from '../../services/insurance-claims.service';
import { InsuranceClaimStatusLookup } from '../../models/insurance-claim-response.model';

@Component({
  selector: 'app-insurance-claim-status-filter',
  standalone: true,
  imports: [NgbDropdownModule, TranslocoPipe],
  templateUrl: './insurance-claim-status-filter.component.html',
  styleUrl: './insurance-claim-status-filter.component.scss'
})
export class InsuranceClaimStatusFilterComponent implements OnInit, OnDestroy {
  private claimsService = inject(InsuranceClaimsService);
  private errorHandlerService = inject(ErrorHandlerService);
  private cancelSubject = new Subject<void>();

  @Input() disabled: boolean = false;
  @Input() selectedStatusId: number | null = null;
  @Output() statusChanged = new EventEmitter<number | null>();

  statuses: InsuranceClaimStatusLookup[] = [];
  isLoading: boolean = false;

  get selectedStatusName(): string | null {
    return this.statuses.find(status => status.id === this.selectedStatusId)?.name ?? null;
  }

  async ngOnInit(): Promise<void> {
    await this.loadStatuses();
  }

  ngOnDestroy(): void {
    this.cancelSubject.next();
    this.cancelSubject.complete();
  }

  onStatusSelect(statusId: number | null): void {
    if (statusId === this.selectedStatusId) {
      return;
    }

    this.selectedStatusId = statusId;
    this.statusChanged.emit(statusId);
  }

  private async loadStatuses(): Promise<void> {
    this.isLoading = true;

    try {
      const response = await this.claimsService.getInsuranceClaimStatuses(this.cancelSubject);
      this.statuses = response.data ?? [];
      this.isLoading = false;
    } catch (error) {
      this.errorHandlerService.handleError(error, {
        callback: () => {
          this.statuses = [];
          this.isLoading = false;
        }
      });
    }
  }
}